<evc-modal
  [showReduceButton]="false"
  [options]="options()"
  [styles]="{ width: '633px', maxWidth: '100%' }">
  <ng-container modal-title>{{ i18n().title | translate }}</ng-container>

  <ng-container modal-content>
    <header class="header">
      @for (item of listedSelectedItems(); track item.id) {
        @if (item.label) {
          <evc-status-indicator
            class="tag"
            [text]="item.label" />
        } @else {
          <drive-file-item [file]="item" />
        }
      }
    </header>

    <form
      class="form"
      modal-content
      [formGroup]="form">
      @if (items().length > 0) {
        <evc-breadcrumb
          size="xs"
          class="breadcrumb"
          [items]="breadcrumbList()"
          [showCurrentLocation]="true"
          (itemSelected)="onCrumbSelected($event)"></evc-breadcrumb>
      }

      @if (isLoading()) {
        <ol
          class="file-list"
          aria-hidden="true">
          @for (row of skeletonRows; track $index) {
            <li class="row">
              <evc-skeleton
                variant="icon"
                size="x-small" />
              <evc-skeleton
                variant="text"
                size="medium"
                width="160px" />
            </li>
          }
        </ol>
      } @else {
        <evc-options-group
          formControlName="targetFolderId"
          name="targetFolderId"
          type="radio">
          <ol class="file-list">
            <li class="row row__current_folder">
              <evc-input
                class="input current-folder"
                type="radio"
                [value]="parentFolderId() ?? 'base'">
                @let currentFolder =
                  {
                    id: parentFolderId(),
                    name: ('browseTarget.currentFolder' | translate),
                    icon: 'folder',
                  };
                <drive-file-item
                  label
                  class="file-item"
                  [file]="currentFolder"
                  (click)="selectFolder(currentFolder)"
                  (dblclick)="selectFolder(currentFolder)" />
              </evc-input>
            </li>

            @for (item of displayedFolders(); track item) {
              <li
                class="row"
                [attr.data-disabled]="item.disabled">
                <evc-input
                  class="input"
                  type="radio"
                  [value]="item.id">
                  <drive-file-item
                    label
                    class="file-item"
                    [file]="item"
                    (click)="selectFolder(item)"
                    (dblclick)="selectAndEnterFolder(item)" />

                  <evc-icon
                    label
                    class="icon"
                    icon="chevron-right"
                    size="md"
                    (click)="selectAndEnterFolder(item)" />
                </evc-input>
              </li>
            }
          </ol>
        </evc-options-group>
      }
    </form>
  </ng-container>

  <evc-button
    data-testid="modal-submit"
    modal-actions
    type="primary"
    [text]="i18n().action | translate"
    (click)="submit()" />
  <evc-button
    data-testid="modal-cancel"
    modal-actions
    frame="ghost"
    [text]="i18n().cancel | translate"
    (click)="close()" />
</evc-modal>
